import type { TrackerStatus } from "@/src/hooks/trackerTypes";

export type TrackerListTrackingStatus = "active" | "paused" | "completed";

export type TrackerStatusLabelKey =
  "Active" | "Paused" | "Completed" | "Stopped";

/** Desk / embed 列表可见的 tracker 状态（剔除 DELETE）。 */
export function isTrackerListVisible(status?: string): boolean {
  return status === "ACTIVE" || status === "STOP" || status === "COMPLETED";
}

/** 仅 ACTIVE tracker 展示未读红点。 */
export function isTrackerUnreadEligible(status?: string): boolean {
  return status === "ACTIVE";
}

/** API status → UI 状态（desk 列表 / 详情 / embed 共用）。 */
export function mapTrackerApiStatusToUi(status?: string): TrackerStatus {
  switch (status) {
    case "ACTIVE":
      return "active";
    case "STOP":
      return "paused";
    case "COMPLETED":
      return "completed";
    default:
      return "stopped";
  }
}

export function getTrackerListTrackingStatus(
  status?: string,
): TrackerListTrackingStatus {
  const uiStatus = mapTrackerApiStatusToUi(status);
  if (uiStatus === "stopped") {
    return "active";
  }
  return uiStatus;
}

export function getTrackerStatusLabelKey(
  uiStatus: TrackerStatus,
): TrackerStatusLabelKey {
  switch (uiStatus) {
    case "active":
      return "Active";
    case "paused":
      return "Paused";
    case "completed":
      return "Completed";
    default:
      return "Stopped";
  }
}

export function getTrackerStatusTextClassName(uiStatus: TrackerStatus): string {
  switch (uiStatus) {
    case "active":
      return "text-content_accent1_primary";
    case "paused":
      return "text-content_accent2_primary";
    case "completed":
      return "text-content_tertiary";
    default:
      return "text-content_tertiary";
  }
}

/** Goal 详情 Plan 卡：COMPLETED=完成；STOP=暂停中（仍在进行）；DELETE=取消。 */
export function resolveTrackerPlanCardStatus(
  trackerStatus?: string,
): "in_progress" | "not_started" | "completed" | "cancelled" {
  switch (trackerStatus) {
    case "COMPLETED":
      return "completed";
    case "STOP":
      return "in_progress";
    case "DELETE":
      return "cancelled";
    case "ACTIVE":
    default:
      return "in_progress";
  }
}
